import { createContext, useContext } from "react";

// The auth context + hook live here (not in AuthProvider.jsx) so that
// AuthProvider.jsx exports only a component — which keeps Vite Fast Refresh
// working (react-refresh/only-export-components).
export const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);
